export default {
  en: {
    HEADER_BULK_TAGS: 'Bulk Tags',
    SEARCH_BULK_TAGS: 'Search Bulk Tags',
    BULK_TAGS_EMPTY: 'You have not uploaded any bulk tags.',
    BULK_TAGS_WARNING: "Bulk tag files not used by any filters are subject to deletion after 14 days. See {url} for more.",

    TABLE_COL_NAME: 'Name',
    TABLE_COL_TAGCOUNT: 'Amount of Tags',
    BULK_TAGS_TABLE_LOADING: 'Loading Bulk Tags',
    TYPE_REVENUE: 'Use Revenue',

    REFERENCES_LOADING: 'Loading References',
    REFERENCES_EMPTY: 'These bulk tags do not not have any references.',

    MESSAGE_DELETE_SUCCESS: 'Bulk Tags Deleted',

    DELETE_BULK_TAGS_CONFIRMATION_TITLE: 'Delete Bulk Tags',
    DELETE_BULK_TAGS_MODAL_TEXT: 'Are you sure you want to delete <strong>{bulkTagsToDeleteName}</strong>?',
    DELETE_BULK_TAGS_MODAL_CHECK_ASSOCIATION_TEXT: 'Determining if <strong>{bulkTagsToDeleteName}</strong> is currently associated with any entities.',
    DELETE_BULK_TAGS_MODAL_ASSOCIATION_TEXT: 'Are you sure you want to delete?<br/><br/><strong>{bulkTagsToDeleteName}</strong> is currently associated with the following entities:',
    DELETE_BULK_TAGS_MODAL_NONE_ASSOCIATION_TEXT: '<strong>{bulkTagsToDeleteName}</strong> is not associated with any entities.',
    DELETE_BULK_TAGS_MODAL_CHECK_ASSOCIATION_ERROR_TEXT: 'An error occurred while determining associated entities, please try again.',
    DELETE_BULK_TAGS_ATTEST_PRE: 'Deleting this file will not remove the tag filters that use it. Please make sure to remove the tag filters before proceeding.',
    DELETE_BULK_TAGS_ATTEST: 'I understand that deleting these Bulk Tags will remove the file itself from the entities above but will not remove the tag filters that use the Bulk Tags.',
    DELETE_BULK_TAGS_ATTEST_NONE: 'I understand that deleting these Bulk Tags will remove it from attached entities.'
  }
};